import React, { useEffect, useState } from "react";
import newsData from "../../data/news.json";
import "./TransitionNews.css";

const TransitionNews = ({ isAlbanian }) => {
  const [selectedProjectIndex, setSelectedProjectIndex] = useState(0);
  const [animationDirection, setAnimationDirection] = useState("");
  const [projects, setProjects] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    setProjects(newsData);

    if (newsData.length > 0) {
      setSelectedProjectIndex(0);
    }

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setShowMore(window.innerWidth >= 2560);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleProjectChange = (newIndex) => {
    if (newIndex === selectedProjectIndex) return;
  
    setAnimationDirection("fade-out");
  
    setTimeout(() => {
      setSelectedProjectIndex(newIndex);
      setAnimationDirection("fade-in");
      setIsExpanded(false);
    }, 500);
  };
  

  const handleNext = () => {
    handleProjectChange((selectedProjectIndex + 1) % projects.length);
  };

  const handlePrevious = () => {
    handleProjectChange(
      (selectedProjectIndex - 1 + projects.length) % projects.length
    );
  };

  const truncateText = (text, maxLength) =>
    text.length > maxLength ? text.substring(0, maxLength) + "..." : text;

  return (
    <div className="transition-news-container">
      <div className="overlay">
        <div className="vertical-line left"></div>
        <div className="vertical-line right"></div>
        <div className="bottom-line"></div>
      </div>

      <div className="transition-news-card-form">
        <div
          className={`transition-news-red-card-select ${
            isExpanded ? "expanded" : "collapsed"
          }`}
         
        >
          <div className="transition-news-red-card-title-mobile"
          onClick={() => setIsExpanded(!isExpanded)}
          >
          {isAlbanian 
    ? projects[selectedProjectIndex]?.titull_lajmesh 
    : projects[selectedProjectIndex]?.news_title}

            <span className="transition-news-red-card-arrow">
              {isExpanded ? "▲" : "▼"}
            </span>
          </div>

          {projects.slice(0, isMobile ? 6 : (isExpanded ? 6 : 4)).map((project, index) => (

              <ul
                className={`transition-news-red-card-title ${
                  selectedProjectIndex === index ? "active" : ""
                }`}
                key={project.newsId}
                onClick={() => handleProjectChange(index)}
              >
                <div className="transition-news-red-card-number">
                  <li>{`${(index + 1).toString().padStart(2, "0")}`}</li>
                  <li className="transition-news-red-card-project-title">
                    {isAlbanian ? project.titull_lajmesh : project.news_title}
                  </li>
                </div>
              </ul>
            ))}
          
          {!isMobile && ( 
  <ul className="transition-news-red-card-title-arrow">
    <li
    onClick={(e) => {
      e.stopPropagation();
      setIsExpanded(!isExpanded);
    }}
  >
      {isExpanded ? 
        <img src="/go-up.png" alt="Up" className="transition-news-down-button" />
        : 
        <img src="/down.png" alt="Down" className="transition-news-down-button" />
      }
    </li>
  </ul>
)}

        </div>

        <div
          className={`transition-news-projects-grid-card ${animationDirection}`}
        >
          {projects.length > 0 && (
            <div className="transition-news-project-card">
              <div className="transition-news-project-content">
                <button
                  className="transition-news-prev-btn"
                  onClick={handlePrevious}
                >
                  <img
                    src="/prev.png"
                    alt="Prev"
                    className="transition-news-prev-btn-img"
                  />
                </button>

                <h2 className="transition-news-project-title">
                  {isAlbanian
                    ? projects[selectedProjectIndex].titull_lajmesh
                    : projects[selectedProjectIndex].news_title}
                </h2>

                <div className="transition-news-project-card-paragraph">
                  <p className="transition-news-project-address">
                    {truncateText(
                      isAlbanian
                        ? projects[selectedProjectIndex].pershkrim_lajmesh
                        : projects[selectedProjectIndex].news_description,
                      100
                    )}
                  </p>
                  <a
                    href={`/newsdetails/${projects[selectedProjectIndex].news_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="transition-news-project-lookmore">
                      {isAlbanian ? "Shiko më shumë →" : "Look more →"}
                    </p>
                  </a>
                </div>
              </div>

              <div className="transition-news-project-image-square">
                <a
                  href={`/newsdetails/${projects[selectedProjectIndex].news_id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={projects[selectedProjectIndex].news_image_url}
                    alt={projects[selectedProjectIndex].news_title}
                    className="transition-news-project-image"
                  />
                </a>
              </div>
              <button className="transition-news-next-btn" onClick={handleNext}>
                <img
                  src="/next.png"
                  alt="Next"
                  className="transition-news-prev-btn-img"
                />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TransitionNews;
